// extracted by mini-css-extract-plugin
export default {"SuggestionContainer":"L3Kz6Q","suggestionContainer":"L3Kz6Q"};